<template>
  <div>
    <div class="baocun">
      <van-button type="warning" >长按图片进行保存</van-button>
    </div>
    <div class="baocunimg"><img :src="src" width="100%" /></div>
    
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;

import Footbar from "./commpents/footbar";

import {
  Button,

} from "vant";

export default {
  components: {
    [Button.name]: Button,

  },

  data() {
    return {
      getInitUrl: root + "post/init",
      configs: [],
      src: ""
    };
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { page: self.page, type: self.type, k: self.k },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          var url = self.$route.query.url;
          self.configs = reponseData.configs;
          self.src = 'http://house.45win.com/'+'upload/'+url;
        },
        error: function() {
          self.$toast("system error");
        }
      });
    }
  }
};
</script>

<style scoped>
.baocun{
  background-color: #fff;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 15px 0;
  text-align: center 

}
.baocun .van-button{
  width: 90%;
}
.baocunimg{
  margin: 20px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  border-radius: 20px
}

</style>>



